import React,{ Component } from 'react';

import Container from '../../components/Container';
import {Row} from 'react-bootstrap';
import Heading from '../../components/Heading';
import NotificationData from './components/NotificationData';

import API from '../../services/API';


class Notification extends Component {
    constructor(props) {
        super(props);

        this.state = {
            notification: {},
            isLoading: false,
            tagid: props.match.params.tagid,
            isArchive: !!props.match.params.archive
        };

    }

    componentDidMount() {
        this.loadNotification();
    }

    loadNotification() {
        this.setState({
            isLoading: true
        });

        API.Notifications.get(this.state.tagid, this.state.isArchive).then(notification => {
            console.log(notification);
            this.setState({
                notification,
                isLoading: false
            });
        })
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Notification"/>
                <Row>
                    <NotificationData
                        notification={this.state.notification}
                    />
                </Row>
            </Container>
        );
    }
}

export default Notification;


// WEBPACK FOOTER //
// ./src/scenes/Notification/index.js